import { render, staticRenderFns } from "./SelectorMotivoBloqueioUsuario.vue?vue&type=template&id=2b3a1ee7&scoped=true"
import script from "./SelectorMotivoBloqueioUsuario.vue?vue&type=script&lang=js"
export * from "./SelectorMotivoBloqueioUsuario.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./SelectorMotivoBloqueioUsuario.vue?vue&type=style&index=2&id=2b3a1ee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a1ee7",
  null
  
)

export default component.exports